var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwoWay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.239665 4.7996C0.543198 5.08145 1.01775 5.06387 1.2996 4.76034L3.25 2.6599L3.25 11.25C3.25 11.6642 3.58579 12 4 12C4.41422 12 4.75 11.6642 4.75 11.25V2.6599L6.70041 4.76034C6.98226 5.06387 7.45681 5.08145 7.76034 4.79959C8.06388 4.51774 8.08145 4.04319 7.7996 3.73966L4.5496 0.239662C4.40769 0.0868364 4.20855 9.11608e-09 4 0C3.79145 -9.11608e-09 3.59232 0.0868364 3.45041 0.239662L0.200408 3.73966C-0.081444 4.04319 -0.0638681 4.51774 0.239665 4.7996ZM8.23967 11.2004C7.93613 11.4823 7.91856 11.9568 8.20041 12.2603L11.4504 15.7603C11.5923 15.9132 11.7915 16 12 16C12.2086 16 12.4077 15.9132 12.5496 15.7603L15.7996 12.2603C16.0815 11.9568 16.0639 11.4823 15.7603 11.2004C15.4568 10.9186 14.9823 10.9361 14.7004 11.2397L12.75 13.3401V4.75C12.75 4.33579 12.4142 4 12 4C11.5858 4 11.25 4.33579 11.25 4.75V13.3401L9.2996 11.2397C9.01775 10.9361 8.5432 10.9186 8.23967 11.2004Z",
    fill: "#F9A01B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwoWay);
export default __webpack_public_path__ + "static/media/two-way.165b9cff5cb08ac747183865a8518738.svg";
export { ForwardRef as ReactComponent };